import React from 'react';
import { get } from 'lodash';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';


import env from '../config/env.json';

const keys = get(
  env,
  `stripe.${process.env.REACT_APP_MODE || process.env.NODE_ENV}`
) || {};
const currencies = get(env, 'stripe.currencies') || [];

class Stripe {
  getPublicKey = currency => get(keys, `${currency}.pk`) || '';

  currentCurrency = 'cad'; // default
  stripePromise = loadStripe(this.getPublicKey(this.currentCurrency));

  availableCurrencies = currencies;

  updateCurrency = currency => {
    if (this.currentCurrency === currency)
      return;

    this.currentCurrency = currency;
    this.stripePromise = loadStripe(this.getPublicKey(currency));
  };

  load = (Component, props = {}) => (
    <Elements stripe={this.stripePromise}>
      <ElementsConsumer>
        {({ elements, stripe }) => (
          <Component elements={elements} stripe={stripe} {...props} />
        )}
      </ElementsConsumer>
    </Elements>
  );
}

export default new Stripe();



// WEBPACK FOOTER //
// ./src/util/stripe.js